module.exports = __webpack_public_path__ + "img/nodata.7ecf3747.png";